import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'

export const IssueReportModalStyle = styled.div`
  padding: 32px 40px 24px;
  
  .issue-report__content {
    max-height: 480px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 480px;
    overflow: scroll;
    margin: 24px 0 12px 0;
  }

  .issue-report__title {
    font-family: NunitoSansBold;
    font-size: ${FONT_SIZE.SM};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    text-align: center;
    padding: 0;
    margin: 0;
  }

  .issue-report__dropdown__select {
    ::-webkit-scrollbar {
      width: 6px;
      border-radius: 3px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      border-radius: 3px;
    }
  }

  .disabled {
    display: none !important;
  }

  .issue-report__dropdown {
    width: 100%;
    position: relative;
    
    &__box {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      font-size: ${FONT_SIZE.XXS};
      background-color: ${COLOR.WHITE};
      border: 1px solid ${COLOR.WHITE_2};
      border-radius: 4px;
      cursor: pointer;
      color: ${COLOR.GRAY_20};
      font-family: NunitoSansSemibold;
      
      ::-webkit-scrollbar {
        width: 6px;
        border-radius: 3px;
        background: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      }
      ::-webkit-scrollbar-thumb {
        background: #666666;
        border-radius: 3px
      }

      img {
        width: 24px;
        height: 24px;
      }
    }

    &__select {
      box-sizing: border-box;
      position: absolute;
      background-color: ${COLOR.WHITE};
      border: 1px solid ${COLOR.WHITE_2};
      width: 100%;
      max-height: 132px;
      overflow-y: scroll;
      border-radius: 4px;
      font-family: NunitoRegular;
    }
    
    &__option {
      box-sizing: border-box;
      cursor: pointer;
      padding: 12px 16px;
      border-radius: 4px;
      width: 100%;
      display: block;
    }

    &__option:hover {
      background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : NATIVE_BASE_COLORS.TEXT[900]};
    }
  }

  .issue-report__issue-detail {
    width: 100%;

    &__title {
      font-size: ${FONT_SIZE.XXS};
      color: ${NATIVE_BASE_COLORS.TEXT[700]};
      margin: 0;
      padding: 0 0 8px 0;
    }

    &__textarea {
      box-sizing: border-box;
      padding: 12px 16px;
      font-size: ${FONT_SIZE.XXS};
      font-family: NunitoRegular;
      border: 1px solid ${COLOR.WHITE_2};
      border-radius: 4px;
      resize: none;
      width: 100%;
    }

    &__textarea::placeholder {
      color: ${COLOR.GRAY_20};
    }
  }

  .issue-report__image-uploader {
    &__title {
      font-size: ${FONT_SIZE.XXS};
      color: ${NATIVE_BASE_COLORS.TEXT[700]};
      margin: 0;
      padding: 0 0 8px 0;

      &--amount {
        color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      }
    }
    
    &__text {
      margin: 0;
      padding: 0px 0;
      color: ${COLOR.GRAY_15};
      font-size: ${FONT_SIZE.TN};
    }

    &__button {
      display: none;
    }

    &__label {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 160px;
      height: 40px;
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.TN};
      background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : NATIVE_BASE_COLORS.TEXT[900]};
      border-radius: 4px;
      cursor: pointer;
      margin: 8px 0 0 0;
    }
  }

  .issue-report__uploaded-photo {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;

    &__item {
      box-sizing: border-box;
      display: grid;
      grid-template-columns: repeat(3, auto);
      align-items: center;
      width: 100%;
      padding: 4px;
      border-radius: 4px;
      border: 1px solid ${COLOR.WHITE_2};
      background-color: ${NATIVE_BASE_COLORS.TEXT[50]};
      height: 40px;
    }

    &__image {
      width: 48px;
      height: 32px;
      object-fit: cover;
      margin-right: 8px;
    }

    &__text {
      margin: 0;
      padding: 0;
      width: 300px;
      text-overflow: ellipsis;
      justify-self: start;
      overflow: hidden;
      white-space: nowrap;
    }

    &__delete-button {
      padding: 0;
      border: 0;
      background-color: transparent;
      justify-self: end;
    }

    &__delete-icon {
      display: block;
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
  }

  .issue-report__button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    button {
      box-sizing: border-box;
      width: 160px;
      height: 40px;
      padding: 10px 12px;
      border-radius: 4px;
      font-family: NunitoSansBold;
      font-size: ${FONT_SIZE.TN};
      cursor: pointer;
    }

    &--back {
      border: 1px solid ${NATIVE_BASE_COLORS.MUTED[300]};
      color: ${NATIVE_BASE_COLORS.TEXT[900]};
      background-color: ${COLOR.WHITE};
    }

    &--send {
      border: 1px solid ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      background-color: ${props => props.colorTheme ? props.colorTheme.MAIN : COLOR.GOLD_1};
      color: ${props => props.colorTheme ? props.colorTheme.FONT_COLOR.SINGLE_TONE : COLOR.BLACK_1}
    }
  }
`
